import type { Finding } from "./Finding";
import { hasImpact } from "./hasImpact";

const WENT_WELL_LIMIT = 3;

// Порядок сильных сторон в «Получилось» у разборов без важности: сначала яркие моменты, потом
// метрики. Ключевых предметов вовремя здесь нет — их показывают покупки (`selectWentWell`).
const ORDER: Partial<Record<Finding["code"], number>> = {
  multi_kill: 0,
  low_hp_survival: 1,
  lane_result: 2,
  metric: 3,
};

// Сильные стороны (`good`) для «Получилось», не больше трёх: по важности, при равной (и у старых
// разборов) — по порядку выше; метрики — лучшие первыми.
export const selectWentWellFindings = (findings: readonly Finding[]): Finding[] => {
  const rated = hasImpact(findings);
  return findings
    .filter((finding) => finding.severity === "good" && ORDER[finding.code] !== undefined)
    .sort(
      (a, b) =>
        (rated ? b.impact - a.impact : 0) ||
        (ORDER[a.code] ?? 0) - (ORDER[b.code] ?? 0) ||
        (b.code === "metric" ? b.params.percentile : 0) -
          (a.code === "metric" ? a.params.percentile : 0),
    )
    .slice(0, WENT_WELL_LIMIT);
};
